<script setup>
import { tableRecipe } from './table.recipe';
import { useTableContext } from './useTable';

const { table } = tableRecipe();

const { rootProps } = useTableContext();
</script>

<template>
  <table data-component="CsTable" :class="table(rootProps)">
    <slot />
  </table>
</template>
